export enum TokenRequestorIdType {
  Merchant = 'MERCHANT',
  Verifone = 'VERIFONE',
}
